import generateSafeframeAdImpl from './safeframe/generateSafeframeAd';
import generateFriendlyIframeAdImpl from './generateFriendlyIframeAd';
import generateCeltraAdImpl from './generateCeltraAd';
import { track } from '../tracking';
import { withAdResponseReceivedEvent } from '../tracking/events';

const getFcidFromHtml = (content) => {
  const fcidAttributeMatch = content.match(/fcid=['|"]([^']+)['|"]/);
  const hasFcid = fcidAttributeMatch && fcidAttributeMatch.length > 0;
  return hasFcid ? fcidAttributeMatch[1] : undefined;
};

export default (
    generateSafeframeAd = generateSafeframeAdImpl,
    generateFriendlyIframeAd = generateFriendlyIframeAdImpl,
    shouldTrackEvent,
    generateCeltraAd = generateCeltraAdImpl,
  ) =>
  (adSpot, response) => {
    const { contentType, content, isTrustedHtml, isTrustedCeltraHtml } =
      response;
    adSpot.nativeType = 'html';
    adSpot.nativeContent = content;

    if (isTrustedHtml) {
      return generateFriendlyIframeAd(adSpot, content);
    }

    if (isTrustedCeltraHtml) {
      return generateCeltraAd(adSpot, content);
    }

    const eventProperties = {
      adResponseContentType: contentType,
      fcid: getFcidFromHtml(content),
    };

    track(
      withAdResponseReceivedEvent(eventProperties),
      adSpot,
      shouldTrackEvent,
    );

    return generateSafeframeAd(adSpot);
  };
